<!--
 * @Author: your name
 * @Date: 2021-06-26 16:38:14
 * @LastEditTime: 2021-06-28 14:32:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\ToolsList\ToolCalendar.vue
-->
<!--日历-->

<template>
  <div class="tool-calendar">ToolCalendar</div>
</template>

<script>
export default {
name: "ToolCalendar"
}
</script>

<style lang="scss" scoped>
.tool-calendar {
  background: red;
}
</style>